// extracted by mini-css-extract-plugin
module.exports = {"mapChart":"antd-pro-pages-dashboard-monitor-style-mapChart","pieCard":"antd-pro-pages-dashboard-monitor-style-pieCard"};